export const TEST_PA_URL = 'https://test.admin.ddocdoc.dev/';
export const PROD_PA_URL = 'https://admin.ddocdoc.dev/';
export const PA_URL =
  process.env.BUILD_ENV === 'test' ? TEST_PA_URL : PROD_PA_URL;
